import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

const STATUS_BG = {
  pending: "bg-peach",
  approved: "bg-lime",
  rejected: "bg-hot text-white",
};

export default function MySubmissions() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/submissions/mine");
        setItems(data.items);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-8 py-10">
      <h1 className="font-display text-5xl tracking-tighter mb-2">your submissions<span className="text-hot">.</span></h1>
      <p className="font-mono-tag text-xs uppercase mb-6">drop more, vibe higher</p>

      {loading ? (
        <p className="font-mono-tag uppercase">loading...</p>
      ) : items.length === 0 ? (
        <div data-testid="empty-mine" className="bg-white brutal p-8 text-center">
          <p className="font-display text-2xl mb-3">no entries yet</p>
          <Link data-testid="empty-mine-cta" to="/submit" className="inline-block bg-hot text-white font-display uppercase px-4 py-2 brutal-sm brutal-hover">drop one →</Link>
        </div>
      ) : (
        <div className="space-y-4">
          {items.map((s) => (
            <div key={s.id} data-testid={`my-submission-${s.id}`} className="bg-white brutal p-5">
              <div className="flex flex-wrap items-start justify-between gap-3 mb-2">
                <h3 className="font-display text-3xl leading-none">{s.word}</h3>
                <span className={`${STATUS_BG[s.status] || "bg-white"} brutal-sm font-mono-tag text-[10px] uppercase px-2 py-1`}>{s.status}</span>
              </div>
              <p className="font-mono-tag text-[10px] uppercase mb-2 inline-block bg-altsoft brutal-sm px-2 py-0.5">{s.category}</p>
              <p className="text-sm mb-2">{s.meaning}</p>
              {s.example && <p className="font-hand text-lg leading-tight">"{s.example}"</p>}
              {s.ai_verdict && (
                <div className="mt-3 bg-altsoft brutal-sm p-3">
                  <p className="font-mono-tag text-[10px] uppercase mb-1">ai screening</p>
                  <p className="text-sm"><b>{s.ai_verdict.approved ? "Recommended" : "Flagged"}:</b> {s.ai_verdict.reason}</p>
                </div>
              )}
              {s.status !== "pending" && s.review_reason && (
                <p className="mt-2 font-mono-tag text-[10px] uppercase">admin note: {s.review_reason}</p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
